import styled from 'styled-components';

export const Layout = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 740px;
  padding-top: 200px;
  padding-bottom: 200px;
`;
export const ColSimple = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 65px;
`;
export const ButtonWrap = styled.div`
  display: flex;
  height: 120px;
  flex-direction: column;
  justify-content: space-between;
  @media (max-width: 540px) {
    flex-direction: column;
  }
`;
